import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { ApiService } from 'services/api.service';
import { AuthorizationService } from 'services/authorization.service';
import { ClientCard, ClientLoginListByLegalEntityIdItem, ClientLoginListItem, DeleteClientRequest } from 'types/client.interface';
import { formatDatetime } from 'util/date.utility';
import { DeleteClientComponent } from '../../modal/delete-client/delete-client.component';
@Component({
  selector: 'app-client-activities',
  standalone: true,
  imports: [TranslateModule, ReactiveFormsModule, SpinnerComponent, TooltipComponent, DeleteClientComponent, NgbPagination],
  templateUrl: './client-activities.component.html',
  styleUrls: ['../../form/base-form.scss', './client-activities.component.scss']
})
export class ClientActivitiesComponent implements OnInit {
  public readonly formatDate = formatDatetime;
  [x: string]: any;
  @Output() clientDelete: EventEmitter<DeleteClientRequest> = new EventEmitter<DeleteClientRequest>();
  @Input() client!: ClientCard;
  @Input() showDelete: boolean = true;
  @Input() legalEntityId?: string;
  isLoginListLoading: boolean = false;
  clientLogins?: ClientLoginListItem[];
  legalEntityLogins?: ClientLoginListByLegalEntityIdItem[];
  visibleLogins: ClientLoginListItem[] = [];
  visibleLegalEntityLogins: ClientLoginListByLegalEntityIdItem[] = [];
  page: number = 1;
  pageSize: number = 10;

  get isLegalEntity(): boolean {
    return !!this.legalEntityId;
  }

  get totalLogins(): number {
    return this.isLegalEntity ? (this.legalEntityLogins?.length || 0) : (this.clientLogins?.length || 0);
  }

  constructor(
    private apiService: ApiService,
    private authService: AuthorizationService
  ) {}

  ngOnInit(): void {
    this.isLoginListLoading = true;

    if (this.isLegalEntity) {
      this.apiService.getLegalEntityLoginList(this.legalEntityId!).subscribe({
        next: (data: ClientLoginListByLegalEntityIdItem[]) => {
          this.legalEntityLogins = data;
          this.legalEntityLogins.sort((a, b) => new Date(b.loggedOn).getTime() - new Date(a.loggedOn).getTime());
          this.visibleLegalEntityLogins = this.legalEntityLogins.slice(0, this.pageSize);
          this.isLoginListLoading = false;
        },
        error: () => {
          this.legalEntityLogins = [];
          this.visibleLegalEntityLogins = [];
          this.isLoginListLoading = false;
        }
      });
    } else {
      this.apiService.getClientLoginList(this.client.id).subscribe((data: ClientLoginListItem[]) => {
        this.clientLogins = data;
        this.clientLogins.sort((a, b) => new Date(b.loggedOn).getTime() - new Date(a.loggedOn).getTime());
        this.visibleLogins = this.clientLogins.slice(0, this.pageSize);
        this.isLoginListLoading = false;
      });
    }
  }

  getAuthenticationTypeName(name: string) {
    switch (name) {
      case 'Local':
        return 'Izveidojis LNA darbinieks';
      case 'NationalId':
        return 'Latvija LV';
      case 'Email':
        return 'E-pasts';
      case 'Unknown':
        return 'Nezināms';
      default:
        return name;
    }
  }

  onDelete(value: DeleteClientRequest): void {
    this.clientDelete.emit(value);
  }

  handlePageChange(page: number): void {
    this.page = page;
    const startIndex = (this.page - 1) * this.pageSize;

    if (this.isLegalEntity && this.legalEntityLogins) {
      this.visibleLegalEntityLogins = this.legalEntityLogins.slice(startIndex, startIndex + this.pageSize);
    } else if (this.clientLogins) {
      this.visibleLogins = this.clientLogins.slice(startIndex, startIndex + this.pageSize);
    }
  }

  onPageSizeChange(pageSize: Event): void {
    this.pageSize = parseInt((pageSize.target as HTMLSelectElement).value);
    const startIndex = (this.page - 1) * this.pageSize;

    if (this.isLegalEntity && this.legalEntityLogins) {
      this.visibleLegalEntityLogins = this.legalEntityLogins.slice(startIndex, startIndex + this.pageSize);
    } else if (this.clientLogins) {
      this.visibleLogins = this.clientLogins.slice(startIndex, startIndex + this.pageSize);
    }
  }
}
